module.exports = {
                    OP_OR: 'or',
                    OP_AND: 'and',
                    OP_DEFAULT: 'or'
                  }
